import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
// import { useAuth } from "../Auth/Auth";
import {apiHeader} from '../../../utils/apiHeader'
import axios from "axios";
import { globalConfig } from "../../../config/config";
// const querystring = require("querystring");

const ManageContentCategories = ({ location }) => {
  const [contentCategoryTypes, setContentCategoryTypes] = useState([]);
  let parms = new URLSearchParams(location.search);
  const [message, setMessage] = useState("");
  const {token,userMetadata}=useAuth()
  const history = useHistory();
  const [state, setState] = useState({
    contentCategoryId: parseInt(parms.get("id")),
    contentId: 0,
    contentCategoryTypeId: 0,
    contentCategoryName: "",
    contentCategoryDescr: "",
    lastUpdateUser: 0,
    securityContextId: 0,
    lastUpdateDate: new Date().toISOString(),
  });
  useEffect(() => {
    handleOnLoad();
  }, []);
  function handleSave(event) {
    console.log("handling save 1");

    event.preventDefault();
    console.log("handling save");
    if (state.securityContextId === null) {
      state.securityContextId = 0;
    }
    var url = `${globalConfig.apiDatahubUrl}/content-categories/${state.contentCategoryId}`;

    axios
      .patch(url, state, apiHeader(token))
      .then((response) => {
        console.log("response.data");
        console.log(response.status + ":" + response.data.contentCategoryId);

        if (response.status === 200) {
          setMessage("Success");
          setInterval(() => {
            window.location.reload();
          }, 1000);
        } else {
          setMessage("Failed");
        }
        console.log(message);
        event.preventDefault();
      })
      .catch((err) => {
        console.log("error - " + err);
      });
    console.log("message info - " + message);
  }
  function handleChange(event) {
    console.log(event);
    var target = event.target;
    console.log(target.id + ":" + target.value);
    setState({
      ...state,
      [target.id]: isNaN(target.value)
        ? target.value
        : target.value === ""
        ? ""
        : parseInt(target.value),
    });

    console.log(state);
  }
  const handleOnLoad = () => {
    axios
      .get(
        `${globalConfig.apiDatahubUrl}/content-category-types`,
        apiHeader(token)
      )
      .then((res) => {
        const contentCategoryTypes = res.data;
        console.log(contentCategoryTypes);
        setContentCategoryTypes(contentCategoryTypes);
      });

    console.log("handleOnLoad() - loading id = " + state.contentCategoryId);
    axios
      .get(
        `${globalConfig.apiDatahubUrl}/content-categories/${state.contentCategoryId}`,
        apiHeader(token)
      )
      .then((res) => {
        const contentType = res.data;
        console.log("contentType");
        console.log(contentType);
        setState(contentType);
        console.log("state");
        console.log(state);
      });
  };

  function onDelete() {
    let deleteID = state.contentCategoryId;
    axios
      .delete(
        `${globalConfig.apiDatahubUrl}/content-categories/` + deleteID,
        apiHeader(token)
      )
      .then((res) => {
        console.log("Delete Response:" + res.data);
        history.goBack();
      })
      .catch((err) => console.log("Err delete:" + err));
  }
  return (
    <form>
      <div className='container-fluid'>
       <button
          type="button"
          className="btn btn btn-outline-secondary mt-2 mb-3"
          onClick={() => history.goBack()}
        >
          Go Back
        </button>
      <h4>Manage Content Categories</h4>
      <hr />
      <div className="form-group row">
        <label className="ContentTitle col-sm-2" value="Choose Category">
          Choose Category
        </label>
        <select
          onchange="submit()"
          id="content_annotation_id"
          className="form-control input-xlarge col-sm-8 col-sm-8"
          value="#{contentCategoryForm.currentContentCategory.contentCategoryId}"
          valueChangeListener="#{contentCategoryForm.get}"
        >
          <option value="#{contentCategoryForm.contentCategorySelectList}" />
        </select>
      </div>
      <hr />
      <div className="form-group row">
        <label className="ContentTitle col-sm-2" value="Content Object Name">
          Content Object Name
        </label>
        <input
          id="contentObjectName"
          readOnly
          className="form-control input-xlarge col-sm-8"
          value={state.contentObjectName}
        />
        {/* <input id="contentObjectName" className="form-control input-xlarge col-sm-8"
				    // value = {state.contentObjectName}
				>
				</input>                        	 */}
      </div>
      <div className="form-group row">
        <label className="ContentTitle col-sm-2" value="Category Type">
          Category Type
        </label>
        <select
          id="contentCategoryTypeId"
          className="form-control input-xlarge col-sm-8"
          onChange={handleChange}
        >
          <option>Click to make selection</option>
          {contentCategoryTypes.map(
            ({ contentCategoryTypeName, contentCategoryTypeId }) => (
              <option key={contentCategoryTypeId} value={contentCategoryTypeId}>
                {contentCategoryTypeName}
              </option>
            )
          )}
        </select>
      </div>
      <div className="form-group row">
        <label className="ContentTitle col-sm-2" value="Category Object">
          Category Object
        </label>
        <input
          id="contentCategoryName"
          className="form-control input-xlarge col-sm-8"
          value={state.contentCategoryName}
          onChange={handleChange}
        />
      </div>
      <div className="form-group row">
        <label className="ContentTitle col-sm-2" value="Description">
          Description
        </label>
        <textarea
          id="contentCategoryDescr"
          className="form-control input-xlarge col-sm-8"
          value={state.contentCategoryDescr}
          onChange={handleChange}
        />
      </div>
      <hr />
      <div className="form-group row">
        <label
          className="ContentTitle col-sm-2"
          value="Last Updated By #{ombUserSession.getUserNameForId(contentTemplateForm.currentContentTemplate.lastUpdateUser)} on "
        >
          Last Updated By
        </label>
        <input
          className="form-control col-sm-1"
          readonly="readonly"
          value={state.lastUpdateUser}
        />
      </div>
      <div className="form-group row">
        <label
          className="ContentTitle col-sm-2"
          value="#{contentTemplateForm.currentContentTemplate.lastUpdateDate}"
        >
          Last Update Date
        </label>
        <input
          className="form-control col-sm-8"
          readonly="readonly"
          value={state.lastUpdateDate.slice(0, 16)}
          type="datetime-local"
        />
      </div>
      <hr />
      <button
        className="btn btn-danger"
        value="Delete"
        onClick={onDelete}
      >
        Delete
      </button>
      &nbsp;
      <button className="btn btn-success" value="Save" onClick={handleSave}>
        {" "}
        Save
      </button>
      &nbsp;

      </div>
    </form>
  );
};

export default ManageContentCategories;
